module.exports = __webpack_public_path__ + "static/1era meetup cuenca-77b4418015a5386a008f04471577cc85.jpg";